import { render, staticRenderFns } from "./NtdInstituteTable.vue?vue&type=template&id=1b96e81f"
import script from "./NtdInstituteTable.vue?vue&type=script&lang=ts"
export * from "./NtdInstituteTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports